var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { List, useRecipe } from "@chakra-ui/react";
/**
 * Creates a SerpJobs component which is a container holding the list of jobs
 */
// CORTEX-3886 should have a discussion of what might be done if requiring
// CORTEX-4264 jobKey is the encrypted job id that used for your sites, it can be different
// from indeed job key or the job key returned by one graph
// TODO: eliminate use of jobKey in this component
export function SerpJobs(props) {
    var recipe = useRecipe({ key: "SerpJobs" });
    var styles = recipe();
    var SerpJobComponent = props.SerpJobComponent, jobs = props.jobs, onClickJob = props.onClickJob;
    return jobs && jobs.length > 0 ? (_jsx(List.Root, __assign({ id: "job-list", tabIndex: -1, css: styles }, { children: jobs.map(function (job) { return (_jsx(List.Item, { children: _jsx(SerpJobComponent, { job: job, onClickJob: onClickJob }) }, job.jobKey)); }) }))) : null;
}
